import { Action } from '../redux';

export enum SessionActionType {
    SET_LAST_ACTIVITY = 'Session > Set Last Activity'
}

export interface ISetLastActivityAction extends Action {
    lastActivity: Date;
}

export interface ISessionActions {
    setLastActivity(lastActivity: Date): ISetLastActivityAction;
}

export class SessionActions implements ISessionActions {
    readonly setLastActivity = this._setLastActivity.bind(this);

    private _setLastActivity(lastActivity: Date): ISetLastActivityAction {
        return {
            type: SessionActionType.SET_LAST_ACTIVITY,
            lastActivity
        };
    }
}
